// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import DynamicEntityRoute from './EntityDetails/DynamicEntity/routes/DynamicEntityRoute';
import {
  buildDynamicInventoryRouteObjects,
  buildDynamicEntityDetailRouteObjects,
  buildDynamicCreateEntityRouteObjects,
  buildDynamicArchivedEntityRouteObjects,
  buildDynamicFallbackRouteObjects,
} from '../../utils/inventoryRouteEngine';

const EntityList = reactLazyRetry(
  () => import('./EntityOperations/EntityList')
);
const ModelInventoryCreateModel = reactLazyRetry(
  () => import('./EntityOperations/CreateModelStepper')
);
const ArchivedEntity = reactLazyRetry(
  () => import('./EntityOperations/ArchivedEntity')
);
const EntityDetailsAssembly = reactLazyRetry(
  () => import('./EntityDetails/EntityDetailsAssembly')
);

/**
 * Builds the entity-type-driven inventory routes (list, create, archived,
 * detail and the generic fallback) for the currently loaded entity types.
 * These are permission-filtered per entity type, so they are composed
 * directly rather than through the static `Routes` metadata array.
 *
 * @param {Array} entityTypes
 * @param {Record<string, 'None' | 'View' | 'Manage'>} userPermissions
 * @returns {import('react-router-dom').RouteObject[]}
 */
export const buildInventoryFeatureRoutes = (
  entityTypes = [],
  userPermissions = {}
) => [
  ...buildDynamicInventoryRouteObjects(
    entityTypes,
    EntityList,
    userPermissions
  ),
  ...buildDynamicCreateEntityRouteObjects(
    entityTypes,
    ModelInventoryCreateModel,
    userPermissions
  ),
  ...buildDynamicArchivedEntityRouteObjects(
    entityTypes,
    ArchivedEntity,
    userPermissions
  ),
  ...buildDynamicEntityDetailRouteObjects(entityTypes, EntityDetailsAssembly),
  ...buildDynamicFallbackRouteObjects(DynamicEntityRoute),
];
